import { DEFAULT_RATING, DEFAULT_USER_RATING_COUNT, } from 'api/app-rating';
import { ROUTER_DATA_LOAD_FULFILLED } from '../router/router-actions';
const initialState = {
    data: {
        rating: DEFAULT_RATING,
        ratingCount: DEFAULT_USER_RATING_COUNT,
    },
};
export default function appRating(state = initialState, action = { type: undefined }) {
    const { type, payload } = action;
    switch (type) {
        case ROUTER_DATA_LOAD_FULFILLED: {
            const { appRating: appRatingData } = payload || {};
            if (appRatingData) {
                return appRatingData;
            }
            return state;
        }
        default:
            return state;
    }
}
